// extracted by mini-css-extract-plugin
module.exports = {"lds-heart":"style_lds-heart__3FAus","div-after":"style_div-after__3wkfi","div-before":"style_div-before__3m-NN"};